import { useState, useCallback } from "react"

/**
 * A hook for a boolean toggle state.
 *
 * **Example**
 *
 * const [on, toggle] = useToggle()
 *
 * - `toggle()`: toggles the state
 * - `toggle(true)`: sets the state to `true`
 * - `toggle(false)`: sets the state to `false`
 * @param {boolean} defaultValue
 */

function useToggle(defaultValue = false) {
  const [state, setState] = useState(defaultValue)

  const toggle = useCallback((value = null) => {
    if (value === true || value === false) {
      setState(value)
    } else {
      setState(previousValue => {
        return !previousValue
      })
    }
  }, [])

  return [state, toggle]
}

export default useToggle
